import { io } from 'socket.io-client';
import config from '../config';

let socket = null;

function getBaseURL() {
  return (config.API_BASE_URL || '').replace(/\/api\/?$/, '');
}

export function getSocket() {
  if (socket) {
    const token = (localStorage.getItem('authToken') || '').replace(/['"]/g, '').trim();
    if (token) {
      try { socket.emit('authenticate', token); } catch {}
    }
    return socket;
  }
  const base = getBaseURL();
  socket = io(base, {
    transports: ['websocket'],
    withCredentials: true
  });
  const token = (localStorage.getItem('authToken') || '').replace(/['"]/g, '').trim();
  if (token) {
    socket.emit('authenticate', token);
  }
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}

export default {
  getSocket,
  disconnectSocket
};
